import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_EN: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrology',
  components_header_media_multi_content_2: 'Meditation',
  components_header_media_multi_content_3: 'Love',
  components_header_text1: 'Guides',
  components_header_text2: 'Blog',
  hero_text: 'Find clarity, balance, and connection.',
  hero_button_text: 'Start your journey',
  components_ressources_subheader_text: 'Tips and inspiration',
  components_ressources_span_text: 'It brings together personal astrology insights, calming meditation practices, and thoughtful love guidance to support self-discovery, emotional balance, and deeper connection.',
  components_ressources_card_1_title: 'Meditation tips',
  components_ressources_card_1_text: 'Quick guide for better calm, breathing and focus.',
  components_ressources_card_2_title: 'Love guidance',
  components_ressources_card_2_text: 'Simple tips to build stronger connection and emotional balance.',
  components_ressources_link: 'Discover more',
  components_notes_and_google_title_1: 'Find clarity',
  components_notes_and_google_title_2: 'Inner Calm',
  components_notes_and_google_title_3: 'Heart Connection',
  media_content_section_multi_1_subheader_text: 'Our podcast',
  media_content_section_multi_2_subheader_text: 'Our meditations',
  media_content_section_multi_3_subheader_text: 'Real Talk on Cosmic Romance',
  page_media_content_menu_antistress: 'Antistress',
  page_media_content_menu_mindfulness: 'Mindfulness',
  page_media_content_menu_energyboost: 'Energy Boost',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Foundations',
  page_media_content_menu_spirituality: 'Spirituality',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psychology',
  page_media_content_menu_trends: 'Trends',
  page_media_content_menu_compatibility: 'Compatibility',
  page_media_content_menu_love: 'Love',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Articles & Insights',
  text2_section_button_more: 'Load More',
  components_text1_section_title: 'GUIDES',
  components_text1_subheader_text: 'Cosmic Knowledge for Daily Alignment',
  components_text1_span_text: 'Align with the rhythms of the universe: explore a curated collection of in-depth astrological and meditative guides designed to awaken inner clarity, deepen self-awareness, and support your journey of soulful, celestial growth.',
  components_text1_card_1_title: 'Open to the Quiet',
  components_text1_card_1_text: 'Begin your journey with foundational meditation and astrology guides—ideal for seekers drawn to inner stillness, cosmic patterns, and personal insight.',
  components_text1_card_3_title: 'Mind–Body Link',
  components_text1_card_3_text: 'Uncover the deeper layers of your inner world. These guides move beyond the surface to reveal meaning, emotion, and mindful patterns that shape your experience.',
  components_text1_card_2_title: 'Reflect & Integrate',
  components_text1_card_2_text: 'From emotional blocks to planetary cycles—these guides offer tools for reflection, healing, and transformation through mindful rituals and astrological wisdom.',
  components_text1_link: 'View All Guides',
  components_footer_text: 'Find clarity, balance your mind and connect with meaning – your place for astrology, meditation and love.',
};